import { render } from "./AdminHeroImgTable.vue?vue&type=template&id=0652a900&scoped=true"
import script from "./AdminHeroImgTable.vue?vue&type=script&lang=js"
export * from "./AdminHeroImgTable.vue?vue&type=script&lang=js"

import "./AdminHeroImgTable.vue?vue&type=style&index=0&id=0652a900&scoped=true&lang=css"

import exportComponent from "/Users/yao/Documents/projects/garden/garden_ts/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0652a900"]])

export default __exports__